/* ALBEUX PRODUCT PAGE: STICKY ADD TO CART
   The sticky bar shows once the customer has scrolled past the real Add to cart button and stays until that button is on screen again.
   Unlike the stock theme it does not hide itself at the bottom of the page. Look and layout are in albeux-product-buy.css.
   To switch it off, delete the albeux-product-buy.js line in snippets/albeux-fixes.liquid. */
(function () {
  'use strict';
  if (window.__albeuxBuy) return;
  window.__albeuxBuy = true;

  var MAIN = "main[data-template^='product']";
  var queued = false;
  var watched = null;
  var mo = ('MutationObserver' in window) ? new MutationObserver(schedule) : null;

  function update() {
    queued = false;
    var bar = document.querySelector(MAIN + ' sticky-add-to-cart .sticky-add-to-cart__bar');
    var btn = document.querySelector(MAIN + ' product-form-component [ref=addToCartButton]');
    if (!bar || !btn) return;

    /* The theme changes data-stuck itself (for example at the footer), so watch it and put it right straight away */
    if (mo && watched !== bar) {
      mo.disconnect();
      mo.observe(bar, { attributes: true, attributeFilter: ['data-stuck'] });
      watched = bar;
    }

    var r = btn.getBoundingClientRect();
    if (!r.width && !r.height) return;
    var want = r.bottom <= 0 ? 'true' : 'false';
    if (bar.getAttribute('data-stuck') !== want) bar.setAttribute('data-stuck', want);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  window.addEventListener('load', function () { schedule(); setTimeout(schedule, 500); setTimeout(schedule, 1500); });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('change', function () { setTimeout(schedule, 400); }, true);
  if (document.readyState !== 'loading') schedule();
  else document.addEventListener('DOMContentLoaded', schedule);
})();
